import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { useIsRiskTemplatesEnabled } from '@Hooks/useIsRiskTemplatesEnabled';

// One answer for every Results-grid file: is the redesign (I360A-2743) on,
// and should per-component driver columns show? The redesign always shows
// them; with it off, the legacy individual-scores flag still decides.
export function useResultsGridFlags() {
	const isRedesign = useIsRiskTemplatesEnabled();
	const isIndividualScoresEnabled = Boolean(
		useIsFeatureEnabled('info-360-risk-datagrid-individual-scores'),
	);
	return {
		isRedesign,
		showDriverColumns: isRedesign || isIndividualScoresEnabled,
	};
}
